import React, { useEffect, useState, memo, createElement } from 'react';
import { ArrowRightIcon, XIcon, AlertTriangleIcon, CheckIcon, CheckCircleIcon, StarIcon, UsersIcon, AlertCircleIcon, HeartIcon, LeafIcon, ClockIcon, ShieldCheckIcon, HelpCircleIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const setCookie = (name: string, value: string, days: number) => {
  const date = new Date();
  date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  const expires = '; expires=' + date.toUTCString();
  document.cookie = name + '=' + value + expires + '; path=/';
};
const getCookie = (name: string) => {
  if (typeof document === 'undefined') return null;
  const nameEQ = name + '=';
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === ' ') c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
declare global {
  interface Window {
    fbq: any;
    _fbq: any;
  }
}
function MetaPixel() {
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (!window.fbq) {
        window.fbq = function () {
          window.fbq.callMethod ? window.fbq.callMethod.apply(window.fbq, arguments) : window.fbq.queue.push(arguments);
        };
        if (!window._fbq) window._fbq = window.fbq;
        window.fbq.push = window.fbq;
        window.fbq.loaded = true;
        window.fbq.version = '2.0';
        window.fbq.queue = [];
        const script = document.createElement('script');
        script.async = true;
        script.defer = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        document.head.appendChild(script);
        window.fbq('init', '1451750992890734');
        window.fbq('track', 'PageView');
      }
    }, 1000);
    return () => clearTimeout(timeoutId);
  }, []);
  return null;
}
function LiveVisitorCounter() {
  const [viewers, setViewers] = useState(50);
  useEffect(() => {
    const interval = setInterval(() => {
      setViewers(prev => {
        const change = Math.random() > 0.3 ? 1 : -1;
        const next = prev + change;
        return next < 50 ? 50 : next > 120 ? 118 : next;
      });
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex items-center text-sm font-medium text-amber-800 bg-amber-100 py-1.5 px-4 rounded-full animate-pulse w-fit border border-amber-200" data-id="element-0">
      <UsersIcon className="h-4 w-4 mr-2" data-id="element-1" />
      <span data-id="element-2">
        <strong data-id="element-3">{viewers}</strong> personas viendo esta página ahora mismo
      </span>
    </div>;
}
const CountdownBadge = memo(function CountdownBadge() {
  const [copiesLeft, setCopiesLeft] = useState(() => {
    if (typeof document !== 'undefined') {
      const storedCount = getCookie('copiesLeft');
      return storedCount ? parseInt(storedCount) : 20;
    }
    return 20;
  });
  useEffect(() => {
    if (!getCookie('copiesLeft')) {
      setCookie('copiesLeft', '20', 30);
    }
    let intervalId: any;
    const timeoutId = setTimeout(() => {
      intervalId = setInterval(() => {
        setCopiesLeft(prev => {
          const newCount = prev > 3 ? prev - 1 : 3;
          setCookie('copiesLeft', newCount.toString(), 30);
          return newCount;
        });
      }, 5000);
    }, 2000);
    return () => {
      clearTimeout(timeoutId);
      if (intervalId) clearInterval(intervalId);
    };
  }, []);
  return <div className="bg-stone-800 text-stone-50 font-bold px-5 py-2.5 rounded-lg shadow-md animate-pulse w-fit mx-auto flex items-center justify-center border border-stone-700" data-id="element-4">
      <ClockIcon className="w-5 h-5 mr-2 text-amber-400" data-id="element-5" />
      Solo {copiesLeft} copias disponibles
    </div>;
});
function Header() {
  return <header className="bg-[#FAF7F2] border-b border-stone-200 py-4 px-5 md:px-8 sticky top-0 z-50 shadow-sm" data-id="element-6">
      <div className="max-w-7xl mx-auto flex justify-between items-center" data-id="element-7">
        <div className="text-stone-800 font-serif font-bold text-xl md:text-2xl tracking-wide flex items-center" data-id="element-8">
          <HeartIcon className="w-6 h-6 mr-2 text-amber-600 fill-amber-600/20" data-id="element-9" />
          CHEF PERRUNO
        </div>
        <a href="#comprar" className="bg-emerald-700 hover:bg-emerald-800 text-white font-bold px-3 py-1.5 md:px-6 md:py-2.5 rounded-full transition-all duration-300 shadow-md text-xs md:text-base transform hover:scale-105 active:scale-95 whitespace-nowrap" data-id="element-10">
          Quiero la Guía
        </a>
      </div>
    </header>;
}
function HeroSection() {
  return <section className="bg-[#FAF7F2] py-12 md:py-20 overflow-hidden" data-id="element-11">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-12">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-13">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold text-stone-800 leading-tight font-serif mb-6" data-id="element-14">
            Chef Perruno: El Secreto para Sanar a tu Perro desde la Cocina
          </h1>
          <h2 className="text-xl md:text-2xl font-semibold text-stone-600 leading-relaxed max-w-3xl mx-auto" data-id="element-15">
            Premios caseros de 5 minutos que eliminan gases, alergias y limpian
            su organismo de los químicos industriales.
          </h2>
        </div>

        <div className="flex flex-col md:flex-row items-center gap-10 md:gap-16" data-id="element-16">
          <div className="md:w-1/2 relative" data-id="element-17">
            <div className="absolute inset-0 bg-amber-200 rounded-2xl transform rotate-3 scale-105 opacity-50" data-id="element-18"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iwDY2Rv9XTBw7KDKMJVVcA/High-end_digital_product_mockup_featuring_202604292201_(1).jpg" alt="Chef Perruno Guía Digital" className="rounded-2xl shadow-2xl w-full object-cover relative z-10 border-4 border-white" data-id="element-19" />
            <div className="absolute -bottom-4 -right-4 bg-emerald-700 text-white px-4 py-2 rounded-lg shadow-xl flex flex-col items-center z-20 rotate-[-5deg]" data-id="element-20">
              <span className="font-medium text-xs uppercase tracking-wider opacity-90" data-id="element-21">
                Oferta Especial
              </span>
              <span className="font-bold text-lg" data-id="element-22">$11.99 USD</span>
            </div>
          </div>

          <div className="md:w-1/2 space-y-6" data-id="element-23">
            <div className="bg-white p-6 rounded-xl shadow-sm border border-stone-100" data-id="element-24">
              <h3 className="text-xl font-bold text-stone-800 mb-3 font-serif flex items-center" data-id="element-25">
                <AlertTriangleIcon className="w-6 h-6 text-amber-500 mr-2" data-id="element-26" />
                ¿Sabes qué hay realmente dentro de esa bolsa de premios
                coloridos que compras en el súper?
              </h3>
              <p className="text-stone-600 text-lg" data-id="element-27">
                La mayoría están llenos de cenizas, conservantes químicos y
                harinas que inflaman el sistema de tu perro.
              </p>
            </div>

            <p className="text-lg text-stone-700 leading-relaxed" data-id="element-28">
              Él no puede elegir su comida, pero tú sí. Si tu perro tiene mal
              aliento, se rasca sin parar o sufre de gases constantes,{' '}
              <strong className="text-stone-900" data-id="element-29">
                su cuerpo te está pidiendo a gritos un cambio.
              </strong>
            </p>

            <div className="pt-4" data-id="element-30">
              <a href="#comprar" className="inline-flex items-center justify-center w-full md:w-auto bg-emerald-700 hover:bg-emerald-800 text-white font-bold px-8 py-4 rounded-full text-xl md:text-2xl transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-31">
                Quiero la Guía <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-32" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function ProblemSection() {
  return <section className="py-16 md:py-24 bg-white" data-id="element-33">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-34">
        <div className="text-center mb-12 md:mb-16" data-id="element-35">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6 font-serif" data-id="element-36">
            La industria no quiere que sepas esto
          </h2>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto leading-relaxed" data-id="element-37">
            La industria de mascotas está diseñada para que los productos duren
            años en un estante, no para que tu perro viva más tiempo. Los
            colorantes artificiales y los rellenos de trigo están
            silenciosamente dañando su hígado y su digestión.
          </p>
          <p className="text-lg text-stone-600 max-w-3xl mx-auto mt-4 font-medium" data-id="element-38">
            Sientes culpa porque sabes que merece algo mejor, pero no tienes
            tiempo para cocinar dietas complicadas, ni quieres gastar una
            fortuna en tiendas orgánicas de lujo.
          </p>
        </div>

        <h3 className="text-2xl font-bold text-center text-stone-800 mb-8 font-serif" data-id="element-39">
          Por qué lo que has intentado no funciona:
        </h3>

        <div className="grid md:grid-cols-3 gap-6 md:gap-8" data-id="element-40">
          <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-2xl border border-stone-200 shadow-sm relative overflow-hidden group hover:shadow-md transition-all" data-id="element-41">
            <div className="absolute top-0 right-0 bg-stone-200 w-16 h-16 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110" data-id="element-42"></div>
            <XIcon className="h-8 w-8 text-red-400 mb-4 relative z-10" data-id="element-43" />
            <h4 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-44">
              Premios "Naturales"
            </h4>
            <p className="text-stone-600" data-id="element-45">
              Suelen ser puro marketing; si lees la letra pequeña, el primer
              ingrediente sigue siendo harina o azúcar.
            </p>
          </div>

          <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-2xl border border-stone-200 shadow-sm relative overflow-hidden group hover:shadow-md transition-all" data-id="element-46">
            <div className="absolute top-0 right-0 bg-stone-200 w-16 h-16 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110" data-id="element-47"></div>
            <XIcon className="h-8 w-8 text-red-400 mb-4 relative z-10" data-id="element-48" />
            <h4 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-49">
              Recetas de Internet
            </h4>
            <p className="text-stone-600" data-id="element-50">
              Suelen ser vagas y no respetan las proporciones seguras para el
              peso y las necesidades específicas de tu mascota.
            </p>
          </div>

          <div className="bg-[#FAF7F2] p-6 md:p-8 rounded-2xl border border-stone-200 shadow-sm relative overflow-hidden group hover:shadow-md transition-all" data-id="element-51">
            <div className="absolute top-0 right-0 bg-stone-200 w-16 h-16 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110" data-id="element-52"></div>
            <XIcon className="h-8 w-8 text-red-400 mb-4 relative z-10" data-id="element-53" />
            <h4 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-54">
              Dietas Crudas (BARF)
            </h4>
            <p className="text-stone-600" data-id="element-55">
              Son demasiado costosas, requieren mucho tiempo y son difíciles de
              preparar correctamente sin riesgo de bacterias.
            </p>
          </div>
        </div>

        <div className="mt-12 text-center" data-id="element-56">
          <a href="#comprar" className="inline-flex items-center text-emerald-700 font-bold hover:text-emerald-800 transition-colors" data-id="element-57">
            Descubre la alternativa segura y económica{' '}
            <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-58" />
          </a>
        </div>
      </div>
    </section>;
}
function MechanismSection() {
  return <section className="py-16 md:py-24 bg-stone-800 text-stone-50" data-id="element-59">
      <div className="max-w-7xl mx-auto px-4 md:px-8" data-id="element-60">
        <div className="flex flex-col lg:flex-row gap-12 items-center" data-id="element-61">
          <div className="lg:w-1/2 space-y-6" data-id="element-62">
            <div className="inline-flex items-center justify-center p-3 bg-stone-700/50 rounded-full mb-2 border border-stone-600" data-id="element-63">
              <LeafIcon className="h-6 w-6 text-emerald-400 mr-2" data-id="element-64" />
              <span className="font-semibold text-emerald-100 tracking-wide uppercase text-sm" data-id="element-65">
                La Solución Definitiva
              </span>
            </div>
            <h2 className="text-3xl md:text-5xl font-bold text-white mb-4 font-serif leading-tight" data-id="element-66">
              El Método de Nutrición Anti-Inflamatoria Express
            </h2>
            <p className="text-lg text-stone-300 leading-relaxed" data-id="element-67">
              No es un libro de cocina tradicional; es un sistema de sustitución
              rápida. Aprenderás a usar ingredientes que ya tienes en tu
              refrigerador para crear "medicina comestible".
            </p>
            <div className="bg-stone-700/40 p-6 rounded-xl border-l-4 border-emerald-500" data-id="element-68">
              <p className="text-lg text-white font-medium" data-id="element-69">
                Sanamos la inflamación desde la raíz, usando alimentos de grado
                humano que restauran el pelaje y la energía de tu compañero en
                días.
              </p>
            </div>
            <ul className="space-y-4 mt-6" data-id="element-70">
              <li className="flex items-start" data-id="element-71">
                <CheckCircleIcon className="h-6 w-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-72" />
                <span className="text-stone-200" data-id="element-73">
                  Ingredientes 100% naturales y seguros.
                </span>
              </li>
              <li className="flex items-start" data-id="element-74">
                <CheckCircleIcon className="h-6 w-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-75" />
                <span className="text-stone-200" data-id="element-76">
                  Preparación en menos de 5 minutos.
                </span>
              </li>
              <li className="flex items-start" data-id="element-77">
                <CheckCircleIcon className="h-6 w-6 text-emerald-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-78" />
                <span className="text-stone-200" data-id="element-79">
                  Resultados visibles en su digestión y pelaje.
                </span>
              </li>
            </ul>
          </div>
          <div className="lg:w-1/2 relative" data-id="element-80">
            <div className="absolute -inset-4 bg-emerald-900/30 rounded-2xl blur-xl" data-id="element-81"></div>
            <img src="https://cdn.magicpatterns.com/uploads/1LPBQNug7h5aFpv3KTj2M1/Split-screen_before-and-after_photo,_commercial_photography_202604292213.jpg" alt="Antes y después de la nutrición anti-inflamatoria" className="rounded-xl shadow-2xl w-full object-cover relative z-10 border border-stone-600" data-id="element-82" />
            <div className="absolute bottom-4 left-1/2 -translate-x-1/2 bg-stone-900/80 backdrop-blur-sm text-white px-6 py-2 rounded-full text-sm font-medium whitespace-nowrap z-20 border border-stone-700" data-id="element-83">
              Resultados reales en semanas
            </div>
          </div>
        </div>
      </div>
    </section>;
}
function WhatYouGetSection() {
  const items = [{
    title: 'Guía Principal',
    desc: 'Recetario Chef Perruno con snacks de 5 minutos.',
    icon: <HeartIcon className="w-6 h-6 text-amber-600" data-id="element-84" />
  }, {
    title: 'Checklist de Auditoría',
    desc: 'Cómo detectar venenos en etiquetas comerciales.',
    icon: <ShieldCheckIcon className="w-6 h-6 text-amber-600" data-id="element-85" />
  }, {
    title: 'Tabla de Porciones',
    desc: 'Cantidades exactas según el peso y edad de tu perro.',
    icon: <CheckCircleIcon className="w-6 h-6 text-amber-600" data-id="element-86" />
  }, {
    title: 'Diario de Reacción',
    desc: 'Hoja de trabajo para identificar qué ingredientes le caen mal.',
    icon: <AlertCircleIcon className="w-6 h-6 text-amber-600" data-id="element-87" />
  }, {
    title: 'Bono Exclusivo',
    desc: 'Guía de Helados Sanadores para días de calor.',
    icon: <StarIcon className="w-6 h-6 text-amber-600" data-id="element-88" />
  }];
  return <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-89">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-90">
        <div className="text-center mb-16" data-id="element-91">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4 font-serif" data-id="element-92">
            Todo lo que obtienes hoy
          </h2>
          <p className="text-lg text-stone-600" data-id="element-93">
            Un sistema completo diseñado para la salud óptima de tu mejor amigo.
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-94">
          {items.map((item, idx) => <div key={idx} className={`bg-white p-6 rounded-xl shadow-sm border border-stone-200 flex flex-col ${idx === 4 ? 'md:col-span-2 lg:col-span-1 bg-amber-50 border-amber-200' : ''}`} data-id="element-95">
              <div className="bg-amber-100 w-12 h-12 rounded-full flex items-center justify-center mb-4" data-id="element-96">
                {item.icon}
              </div>
              <h3 className="text-xl font-bold text-stone-800 mb-2 font-serif" data-id="element-97">
                {item.title}
              </h3>
              <p className="text-stone-600 flex-grow" data-id="element-98">{item.desc}</p>
            </div>)}
        </div>

        <div className="mt-12 text-center" data-id="element-99">
          <a href="#comprar" className="inline-flex items-center justify-center bg-emerald-700 hover:bg-emerald-800 text-white font-bold px-8 py-4 rounded-full text-xl md:text-2xl transition-all duration-300 shadow-lg transform hover:-translate-y-1" data-id="element-100">
            Quiero la Guía <ArrowRightIcon className="ml-2 h-5 w-5" data-id="element-101" />
          </a>
        </div>
      </div>
    </section>;
}
function TargetAudienceSection() {
  return <section className="py-16 bg-white" data-id="element-102">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-103">
        <div className="grid md:grid-cols-2 gap-8 lg:gap-12" data-id="element-104">
          {/* For Who */}
          <div className="bg-emerald-50 p-8 rounded-2xl border border-emerald-100" data-id="element-105">
            <h3 className="text-2xl font-bold text-emerald-900 mb-6 font-serif flex items-center" data-id="element-106">
              <CheckCircleIcon className="w-8 h-8 text-emerald-600 mr-3" data-id="element-107" />
              Este programa ES para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-108">
              <li className="flex items-start" data-id="element-109">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-110" />
                <span className="text-stone-700" data-id="element-111">
                  Eres dueña de un "perrhijo" y quieres lo mejor para su
                  mascota.
                </span>
              </li>
              <li className="flex items-start" data-id="element-112">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-113" />
                <span className="text-stone-700" data-id="element-114">
                  Tu perro sufre de alergias en la piel, picazón o gases
                  constantes.
                </span>
              </li>
              <li className="flex items-start" data-id="element-115">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-116" />
                <span className="text-stone-700" data-id="element-117">
                  Buscas fortalecer el vínculo con tu mascota a través del
                  refuerzo positivo.
                </span>
              </li>
              <li className="flex items-start" data-id="element-118">
                <CheckIcon className="h-6 w-6 text-emerald-600 mr-3 flex-shrink-0 mt-0.5" data-id="element-119" />
                <span className="text-stone-700" data-id="element-120">
                  Tienes poco tiempo pero no quieres sacrificar la salud de tu
                  perro.
                </span>
              </li>
            </ul>
          </div>

          {/* Not For Who */}
          <div className="bg-red-50 p-8 rounded-2xl border border-red-100" data-id="element-121">
            <h3 className="text-2xl font-bold text-red-900 mb-6 font-serif flex items-center" data-id="element-122">
              <XIcon className="w-8 h-8 text-red-500 mr-3" data-id="element-123" />
              Este programa NO es para ti si...
            </h3>
            <ul className="space-y-4" data-id="element-124">
              <li className="flex items-start" data-id="element-125">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-126" />
                <span className="text-stone-700" data-id="element-127">
                  Buscas una guía de nutrición clínica para enfermedades
                  terminales.
                </span>
              </li>
              <li className="flex items-start" data-id="element-128">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-129" />
                <span className="text-stone-700" data-id="element-130">
                  No estás dispuesta a dedicar 5 minutos a la semana a tu
                  mascota.
                </span>
              </li>
              <li className="flex items-start" data-id="element-131">
                <XIcon className="h-6 w-6 text-red-400 mr-3 flex-shrink-0 mt-0.5" data-id="element-132" />
                <span className="text-stone-700" data-id="element-133">
                  Prefieres la comodidad del ultra-procesado sin importar las
                  consecuencias a largo plazo.
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>;
}
function HowItWorksSection() {
  return <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-134">
      <div className="max-w-7xl mx-auto px-5 md:px-8" data-id="element-135">
        <div className="text-center mb-16" data-id="element-136">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-4 font-serif" data-id="element-137">
            ¿Cómo funciona?
          </h2>
          <p className="text-lg text-stone-600" data-id="element-138">
            Un proceso simple de 3 pasos para transformar su salud.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 relative" data-id="element-139">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-1/2 left-1/6 right-1/6 h-0.5 bg-amber-200 -z-10 transform -translate-y-1/2" data-id="element-140"></div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center relative z-10" data-id="element-141">
            <div className="w-16 h-16 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 border-4 border-white shadow-sm" data-id="element-142">
              1
            </div>
            <h3 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-143">
              Identifica
            </h3>
            <p className="text-stone-600" data-id="element-144">
              Identifica los ingredientes "medicina" que ya tienes en tu propia
              casa y cocina.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center relative z-10" data-id="element-145">
            <div className="w-16 h-16 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 border-4 border-white shadow-sm" data-id="element-146">
              2
            </div>
            <h3 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-147">
              Prepara
            </h3>
            <p className="text-stone-600" data-id="element-148">
              Sigue nuestras recetas express de mezcla y horneado rápido en solo
              5 minutos.
            </p>
          </div>

          <div className="bg-white p-8 rounded-2xl shadow-sm border border-stone-100 text-center relative z-10" data-id="element-149">
            <div className="w-16 h-16 bg-amber-100 text-amber-700 rounded-full flex items-center justify-center text-2xl font-bold mx-auto mb-6 border-4 border-white shadow-sm" data-id="element-150">
              3
            </div>
            <h3 className="text-xl font-bold text-stone-800 mb-3 font-serif" data-id="element-151">
              Observa
            </h3>
            <p className="text-stone-600" data-id="element-152">
              Observa cómo el brillo de su pelo y su energía vital regresan en
              menos de 14 días.
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function ProofSection() {
  return <section className="py-16 bg-white" data-id="element-153">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-154">
        <div className="bg-amber-50 rounded-3xl p-8 md:p-12 border border-amber-100 shadow-sm text-center" data-id="element-155">
          <StarIcon className="w-12 h-12 text-amber-400 mx-auto mb-6 fill-amber-400" data-id="element-156" />
          <h2 className="text-2xl md:text-3xl font-bold text-stone-800 mb-6 font-serif" data-id="element-157">
            Lo que cambia en solo 7 días:
          </h2>
          <p className="text-lg md:text-xl text-stone-700 leading-relaxed italic" data-id="element-158">
            "Notarás que su aliento ya no es fétido, sus deposiciones son firmes
            y pequeñas (señal de absorción total) y ese rascado incesante por
            alergias alimentarias comienza a desaparecer mágicamente."
          </p>
        </div>
      </div>
    </section>;
}
function FAQSection() {
  const faqs = [{
    q: '¿Necesito utensilios caros?',
    a: 'No, basta con un horno pequeño o microondas y recipientes básicos que ya tienes en tu cocina.'
  }, {
    q: '¿Es caro cocinarles?',
    a: 'Al contrario, usar ingredientes como avena y huevo es mucho más barato que comprar premios de marca premium llenos de químicos.'
  }, {
    q: '¿Sirve para perros pequeños?',
    a: 'Sí, incluimos la guía de proporciones exactas para todas las tallas y edades.'
  }, {
    q: '¿Cuánto duran las galletas?',
    a: 'Hasta 7 días en un frasco hermético y hasta un mes si las guardas en el congelador.'
  }];
  return <section className="py-16 md:py-24 bg-[#FAF7F2]" data-id="element-159">
      <div className="max-w-3xl mx-auto px-5 md:px-8" data-id="element-160">
        <div className="text-center mb-12" data-id="element-161">
          <HelpCircleIcon className="w-10 h-10 text-amber-600 mx-auto mb-4" data-id="element-162" />
          <h2 className="text-3xl font-bold text-stone-800 font-serif" data-id="element-163">
            Preguntas Frecuentes
          </h2>
        </div>
        <div className="space-y-4" data-id="element-164">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white p-6 rounded-xl shadow-sm border border-stone-200" data-id="element-165">
              <h3 className="text-lg font-bold text-stone-800 mb-2 font-serif flex items-start" data-id="element-166">
                <span className="text-amber-600 mr-2" data-id="element-167">Q:</span> {faq.q}
              </h3>
              <p className="text-stone-600 pl-6" data-id="element-168">{faq.a}</p>
            </div>)}
        </div>
      </div>
    </section>;
}
const PricingCard = memo(({
  handleBuyClick
}: {
  handleBuyClick: () => void;
}) => <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-amber-100 transform transition-all hover:scale-[1.02]" data-id="element-169">
      <div className="bg-emerald-800 p-6 md:p-8 text-white text-center relative overflow-hidden" data-id="element-170">
        <div className="absolute top-0 right-0 -mt-4 -mr-4 w-24 h-24 bg-emerald-700 rounded-full opacity-50" data-id="element-171"></div>
        <div className="absolute bottom-0 left-0 -mb-4 -ml-4 w-20 h-20 bg-emerald-900 rounded-full opacity-50" data-id="element-172"></div>
        <h3 className="text-2xl md:text-3xl font-bold mb-2 font-serif relative z-10" data-id="element-173">
          CHEF PERRUNO
        </h3>
        <p className="text-emerald-100 font-medium relative z-10" data-id="element-174">
          Acceso completo al sistema + Bonos
        </p>
      </div>
      <div className="p-8 md:p-10" data-id="element-175">
        <div className="flex flex-col justify-center items-center mb-6" data-id="element-176">
          <span className="text-stone-400 text-xl line-through mb-1 font-medium" data-id="element-177">
            $55.99 USD
          </span>
          <span className="text-5xl md:text-6xl font-bold text-stone-800 tracking-tight" data-id="element-178">
            $11.99{' '}
            <span className="text-2xl text-stone-500 font-medium" data-id="element-179">USD</span>
          </span>
        </div>

        <div className="bg-amber-50 border-l-4 border-amber-500 p-4 mb-8 rounded-r-lg flex items-start" data-id="element-180">
          <ClockIcon className="h-6 w-6 text-amber-600 mr-3 flex-shrink-0" data-id="element-181" />
          <p className="text-stone-800 font-medium text-sm" data-id="element-182">
            <span className="font-bold block text-base mb-1" data-id="element-183">
              ¡Oferta por tiempo limitado!
            </span>
            Dale a tu perro la longevidad que se merece por el precio de una
            bolsa de premios industriales.
          </p>
        </div>

        <a href="https://pay.hotmart.com/M105619700U" onClick={handleBuyClick} className="block w-full bg-emerald-600 hover:bg-emerald-700 text-white text-center font-bold px-6 py-5 rounded-xl text-lg md:text-xl transition-all duration-300 shadow-xl transform hover:-translate-y-1" data-id="element-184">
          ¡SÍ, QUIERO SANAR A MI PERRO!
        </a>
        <p className="text-center text-sm text-stone-500 mt-4 font-medium" data-id="element-185">
          Acceso instantáneo después de tu compra segura.
        </p>

        <div className="mt-8 pt-8 border-t border-stone-100" data-id="element-186">
          <ul className="space-y-4" data-id="element-187">
            <li className="flex items-center text-stone-700 font-medium" data-id="element-188">
              <CheckCircleIcon className="h-5 w-5 mr-3 text-emerald-500" data-id="element-189" />{' '}
              Descarga inmediata
            </li>
            <li className="flex items-center text-stone-700 font-medium" data-id="element-190">
              <CheckCircleIcon className="h-5 w-5 mr-3 text-emerald-500" data-id="element-191" />{' '}
              Acceso de por vida
            </li>
            <li className="flex items-center text-stone-700 font-medium" data-id="element-192">
              <CheckCircleIcon className="h-5 w-5 mr-3 text-emerald-500" data-id="element-193" />{' '}
              Compatible con cualquier dispositivo
            </li>
          </ul>
        </div>
      </div>
    </div>);
function PricingSection() {
  const handleBuyClick = () => {
    if (window.fbq) window.fbq('track', 'AddToCart');
  };
  return <section id="comprar" className="py-16 md:py-24 bg-white relative overflow-hidden" data-id="element-194">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-64 bg-gradient-to-b from-[#FAF7F2] to-white" data-id="element-195"></div>

      <div className="max-w-7xl mx-auto px-5 md:px-8 relative z-10" data-id="element-196">
        <div className="mb-8 flex justify-center" data-id="element-197">
          <LiveVisitorCounter data-id="element-198" />
        </div>

        <div className="text-center mb-12" data-id="element-199">
          <h2 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6 font-serif" data-id="element-200">
            Únete a la revolución de la nutrición canina
          </h2>
          <div className="mb-8" data-id="element-201">
            <CountdownBadge data-id="element-202" />
          </div>
        </div>

        <div className="max-w-lg mx-auto" data-id="element-203">
          <PricingCard handleBuyClick={handleBuyClick} data-id="element-204" />
        </div>
      </div>
    </section>;
}
function RecentPurchaseNotification() {
  const purchases = [{
    name: 'Laura',
    location: 'Madrid',
    time: '2 minutos',
    price: '$11.99 USD'
  }, {
    name: 'Carmen',
    location: 'Buenos Aires',
    time: '5 minutos',
    price: '$11.99 USD'
  }, {
    name: 'Sofía',
    location: 'Bogotá',
    time: '1 minuto',
    price: '$11.99 USD'
  }, {
    name: 'Andrea',
    location: 'México DF',
    time: '30 segundos',
    price: '$11.99 USD'
  }];
  const [visible, setVisible] = useState(false);
  const [currentPurchase, setCurrentPurchase] = useState(purchases[0]);
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentPurchase(purchases[Math.floor(Math.random() * purchases.length)]);
      setVisible(true);
      setTimeout(() => setVisible(false), 4000);
    }, 12000);
    return () => clearInterval(interval);
  }, []);
  return <div className={`fixed bottom-6 left-1/2 -translate-x-1/2 md:left-6 md:translate-x-0 z-50 w-[90%] max-w-[320px] bg-white/95 backdrop-blur-md rounded-xl shadow-2xl border border-emerald-100 transition-all duration-700 ease-in-out ${visible ? 'opacity-100 translate-y-0 scale-100' : 'opacity-0 translate-y-8 scale-95 pointer-events-none'}`} data-id="element-205">
      <div className="p-4 flex items-start" data-id="element-206">
        <div className="bg-emerald-100 p-2 rounded-full mr-3 mt-1" data-id="element-207">
          <HeartIcon className="w-4 h-4 text-emerald-600 fill-emerald-600" data-id="element-208" />
        </div>
        <div className="flex-1" data-id="element-209">
          <div className="flex justify-between items-center mb-1" data-id="element-210">
            <span className="text-sm font-bold text-stone-800 font-serif" data-id="element-211">
              Chef Perruno
            </span>
            <span className="text-xs text-stone-500" data-id="element-212">
              Hace {currentPurchase.time}
            </span>
          </div>
          <p className="text-sm text-stone-600 leading-tight" data-id="element-213">
            <span className="font-semibold text-stone-800" data-id="element-214">
              {currentPurchase.name}
            </span>{' '}
            de {currentPurchase.location} acaba de comprar por{' '}
            {currentPurchase.price}
          </p>
        </div>
      </div>
    </div>;
}
function LegalModal({
  isOpen,
  onClose,
  title,
  content
}: any) {
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-stone-900/60 backdrop-blur-sm" data-id="element-215">
      <div className="relative w-full max-w-2xl max-h-[90vh] overflow-auto bg-white rounded-2xl shadow-2xl" data-id="element-216">
        <div className="sticky top-0 bg-white border-b border-stone-100 p-5 flex justify-between items-center z-10" data-id="element-217">
          <h2 className="text-xl font-bold text-stone-800 font-serif" data-id="element-218">
            {title}
          </h2>
          <button onClick={onClose} className="p-2 rounded-full hover:bg-stone-100 transition-colors" data-id="element-219">
            <XIcon className="h-5 w-5 text-stone-500" data-id="element-220" />
          </button>
        </div>
        <div className="p-6 md:p-8 text-stone-600 text-sm leading-relaxed" data-id="element-221">
          {content}
        </div>
      </div>
    </div>;
}
function Footer() {
  const [activeModal, setActiveModal] = useState<string | null>(null);
  return <footer className="bg-stone-900 text-stone-400 py-12" data-id="element-222">
      <div className="max-w-7xl mx-auto px-5 md:px-8 text-center" data-id="element-223">
        <div className="text-stone-200 font-bold text-xl mb-4 font-serif flex items-center justify-center" data-id="element-224">
          <HeartIcon className="w-5 h-5 mr-2 text-amber-500" data-id="element-225" />
          CHEF PERRUNO
        </div>
        <p className="text-sm mb-6 max-w-md mx-auto" data-id="element-226">
          Dedicados a mejorar la vida de tu mejor amigo a través de la nutrición
          natural y consciente.
        </p>
        <p className="text-sm" data-id="element-227">
          © {new Date().getFullYear()} Todos los derechos reservados
        </p>
        <div className="mt-6 flex justify-center space-x-6 text-sm font-medium" data-id="element-228">
          <button onClick={() => setActiveModal('terms')} className="hover:text-amber-400 transition-colors" data-id="element-229">
            Términos
          </button>
          <button onClick={() => setActiveModal('privacy')} className="hover:text-amber-400 transition-colors" data-id="element-230">
            Privacidad
          </button>
        </div>
      </div>

      <LegalModal isOpen={activeModal !== null} onClose={() => setActiveModal(null)} title={activeModal === 'terms' ? 'Términos y Condiciones' : 'Política de Privacidad'} content={<div className="space-y-4" data-id="element-232">
            <p data-id="element-233">
              Este es un texto legal de ejemplo. Al adquirir "Chef Perruno",
              aceptas utilizarlo para fines personales y no redistribuir su
              contenido.
            </p>
            <p data-id="element-234">
              La información proporcionada no sustituye el consejo veterinario
              profesional. Siempre consulta con tu veterinario antes de realizar
              cambios drásticos en la dieta de tu mascota, especialmente si
              tiene condiciones médicas preexistentes.
            </p>
            <p data-id="element-235">
              Implementamos medidas de seguridad para proteger tu información.
              No compartimos datos con terceros sin tu consentimiento.
            </p>
          </div>} data-id="element-231" />
    </footer>;
}
export function App() {
  return <div className="w-full min-h-screen flex flex-col" data-id="element-236">
      <MetaPixel data-id="element-237" />
      <Header data-id="element-238" />
      <main className="flex-grow" data-id="element-239">
        <div className="max-w-7xl mx-auto px-5 md:px-8 mt-6 flex justify-center" data-id="element-240">
          <LiveVisitorCounter data-id="element-241" />
        </div>
        <HeroSection data-id="element-242" />
        <ProblemSection data-id="element-243" />
        <MechanismSection data-id="element-244" />
        <WhatYouGetSection data-id="element-245" />
        <TargetAudienceSection data-id="element-246" />
        <HowItWorksSection data-id="element-247" />
        <ProofSection data-id="element-248" />
        <FAQSection data-id="element-249" />
        <PricingSection data-id="element-250" />
      </main>
      <Footer data-id="element-251" />
      <RecentPurchaseNotification data-id="element-252" />
    </div>;
}